<template>
  <div>
    <h3
      id="table_5"
      class="mt-3"
    >
      Gevraagde en gerealiseerde laadpunten per stelsel
    </h3>
    <TableManager
      ref="TableManager"
      class="RVBChargingpointCount"
      :loading="loading"
      :source-records="records"
      category="rvb-customer-reporting"
      uuid="67d40fce-cd01-435b-ad2c-6574e1bc4c8c"
    />
  </div>
</template>

<script>

import TableManager from '@/components/Table/TableManager'
import { mapGetters } from 'vuex'

export default {
  name: '',
  components: {
    TableManager,
  },

  computed: {
    ...mapGetters('realisation', [
      'records',
      'loading',
    ]),
  },

}
</script>

<style lang="scss">
.RVBChargingpointCount {
  // .Table__row {
  //   div:first-child {
  //     font-weight: bold;
  //   }
  // }
  .Table__row:last-child {
    font-weight: bold;
  }
}
</style>
